import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Font } from './font';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private _url = '/texcrop/api?';
  public set url(value: string) {
    this._url = value;
  }
  public get url() {
    return this._url;
  }

  private b2s(b: boolean): string {
    return b ? '1' : '0';
  }

  constructor(
    private http: HttpClient
  ) { }

  private query(param: any) : string {
    let list = [];
    for (let key in param) {
      list.push(key + "=" + param[key]);
    }
    return list.join('&');
  }

  public getSample(): Observable<string> {
    const url = this._url + this.query({ c: 'sample' });
    return this.http.get(url, {responseType: 'text'});
  }

  public getFonts(): Observable<Font[]> {
    const url = this._url + this.query({ c: 'fonts' });
    return this.http.get<Font[]>(url);
  }

  public getJFonts(): Observable<Font[]> {
    const url = this._url + this.query({ c: 'jfonts' });
    return this.http.get<Font[]>(url);
  }

  public getQuery(tex: string, resolution: number, font: string, jfont: string, bold: boolean,
                  opaque: boolean): string {
    const param = { t: encodeURIComponent(tex),
                    r: resolution, f: font, j: jfont,
                    b: this.b2s(bold), o: this.b2s(opaque) };
    const query = this.query(param);
    return query;
  }

  public getImage(tex: string, resolution: number, font: string, jfont: string, bold: boolean,
                  opaque: boolean, filetype: string): Observable<Blob> {
    const param = { c: filetype, r: resolution, f: font, j: jfont,
                    b: this.b2s(bold), o: this.b2s(opaque),
                    t: encodeURIComponent(tex) };
    const url = this._url + this.query(param);
    return this.http.get(url, {responseType: 'blob'});
  }
}

